"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfShiftRequestAbbrDto = instanceOfShiftRequestAbbrDto;
exports.ShiftRequestAbbrDtoFromJSON = ShiftRequestAbbrDtoFromJSON;
exports.ShiftRequestAbbrDtoFromJSONTyped = ShiftRequestAbbrDtoFromJSONTyped;
exports.ShiftRequestAbbrDtoToJSON = ShiftRequestAbbrDtoToJSON;
exports.ShiftRequestAbbrDtoToJSONTyped = ShiftRequestAbbrDtoToJSONTyped;
const ShiftRequestStatus_1 = require("./ShiftRequestStatus");
const RequestedBy_1 = require("./RequestedBy");
/**
 * Check if a given object implements the ShiftRequestAbbrDto interface.
 */
function instanceOfShiftRequestAbbrDto(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('nurseProfileId' in value) || value['nurseProfileId'] === undefined)
        return false;
    if (!('requestedBy' in value) || value['requestedBy'] === undefined)
        return false;
    return true;
}
function ShiftRequestAbbrDtoFromJSON(json) {
    return ShiftRequestAbbrDtoFromJSONTyped(json, false);
}
function ShiftRequestAbbrDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'status': (0, ShiftRequestStatus_1.ShiftRequestStatusFromJSON)(json['status']),
        'nurseProfileId': json['nurseProfileId'],
        'requestedBy': (0, RequestedBy_1.RequestedByFromJSON)(json['requestedBy']),
        'hasProposal': json['hasProposal'] == null ? undefined : json['hasProposal'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}
function ShiftRequestAbbrDtoToJSON(json) {
    return ShiftRequestAbbrDtoToJSONTyped(json, false);
}
function ShiftRequestAbbrDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'status': (0, ShiftRequestStatus_1.ShiftRequestStatusToJSON)(value['status']),
        'nurseProfileId': value['nurseProfileId'],
        'requestedBy': (0, RequestedBy_1.RequestedByToJSON)(value['requestedBy']),
        'hasProposal': value['hasProposal'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
    };
}
//# sourceMappingURL=ShiftRequestAbbrDto.js.map